(window.webpackJsonp=window.webpackJsonp||[]).push([[580],{
/***/"+Z0c":
/***/function(e,t,s){"use strict";
/* harmony import */var i=s("Rukz"),o=s("4fQY"),n=(s("SMGt"),s("Uolk"),s("WKed"),s("hR6X")),a=s("jimv"),r=s("DQGw"),l=s("3xkH"),c=s("6Bdj");
/* harmony import */class d extends i.b{static get styles(){return[n.fb]}static get properties(){return{customer:{type:String},bookmarks:{type:Array},items:{type:Object},startLevel:{type:String},handleBookmarks:{type:Boolean},showMenu:{type:Boolean},showBookmarks:{type:Boolean},width:{type:String},isopen:{type:Boolean},showSearch:{type:Boolean},fullWidth:{type:Boolean},
//private propertiess
_preparedItemsIndexByParent:{attribute:!1},_preparedItemsTree:{attribute:!1},_preparedBookmarks:{attribute:!1},_searchList:{attribute:!1},_pinnedMenu:{attribute:!1},_slicedArray:{attribute:!1},_showFullMenu:{attribute:!1}}}render(){return i.d`
      <div
        id="overlay"
        class="${this.isopen?"":"active"}"
        @click="${()=>r.a.dispatch(Object(l.K)(!Object(c.f)(r.a.getState())))}"
      ></div>
      <div id="mySidenav" class="sidenav ${this.fullWidth?"full-width":""} ${this.isopen?"open":""}">
        <div class="menu-searchbox flex ${this.showSearch?"":"hidden"}">
          <div class="flex-container level">
            <fontawesome-icon
              style="font-size: 28px; cursor: pointer;"
              prefix="fas"
              name="times"
              fixed-width
              @click="${()=>r.a.dispatch(Object(l.K)(!Object(c.f)(r.a.getState())))}"
            ></fontawesome-icon>
            <six-button
              class="btn-sm ${this._pinnedMenu?"btn-default-outline":"btn-default"} pull-right"
              icon="thumbtack"
              @click="${this._handlePinnedMenu}"
            ></six-button>
          </div>
          <div class="search-container">
            <input id="search" type="text" @keyup="${e=>this._menuSearchHandler(e)}" placeholder="${Object(a.a)("COMMON.SEARCH")}" value="" />
          </div>
        </div>
        <div class="bookmarks-entries">
          ${this._showFullMenu?o.g:this._slicedArray.map(e=>i.d`
                  <div class="flex-container item">
                    <div class="icon-container"></div>
                    <div class="title-container">
                      <a href="${e.code}" @click=${t=>this._menuClickHandler(t,e)}> ${this._itemDescription(e)} </a>
                    </div>
                    <div class="icon-container ${this._itemIsBookmark(e)?"color-star":"low-op"}">
                      <fontawesome-icon
                        prefix="fas"
                        name="star"
                        fixed-width
                        @click="${()=>this._bookmarksHandler(e,!this._itemIsBookmark(e))}"
                      ></fontawesome-icon>
                    </div>
                  </div>
                `)}
          ${this._showFullMenu?Object.values(this._searchList).map(e=>i.d`
                    <div class="flex-container item">
                      <div class="icon-container"></div>
                      <div class="title-container">
                        <a href="${e.code}" @click=${t=>this._menuClickHandler(t,e)}> ${this._itemDescription(e)} </a>
                      </div>
                      <div class="icon-container ${this._itemIsBookmark(e)?"color-star":"low-op"}">
                        <fontawesome-icon
                          prefix="fas"
                          name="star"
                          fixed-width
                          @click="${()=>this._bookmarksHandler(e,!this._itemIsBookmark(e))}"
                        ></fontawesome-icon>
                      </div>
                    </div>
                  `):o.g}
          ${this._searchList.length&&this._searchList.length>10?i.d`
                <div class="expandable-menu">
                  <fontawesome-icon
                    prefix="fas"
                    style="cursor: pointer;"
                    name="${this._showFullMenu?"arrow-up":"arrow-down"}"
                    fixed-width
                    @click="${()=>this._showFullMenu=!this._showFullMenu}"
                  ></fontawesome-icon>
                </div>
              `:o.g}
        </div>
        ${Object.keys(this._preparedBookmarks).length?i.d`
              <div class="bookmarks ${this.fullWidth?"full-width":""}">
                <div class="flex-container level">
                  <div class="icon-container"></div>
                  <div class="icon-container">
                    <fontawesome-icon prefix="fas" name="star" fixed-width></fontawesome-icon>
                  </div>

                  <div class="level-title cursor-pointer" @click="${this._collapseBookmarks}">Bookmarks</div>

                  <div class="icon-container">
                    <fontawesome-icon
                      class=".icon-small"
                      prefix="fas"
                      name="${this.showBookmarks?"minus":"plus"}"
                      @click="${this._collapseBookmarks}"
                      fixed-width
                    ></fontawesome-icon>
                  </div>
                </div>
                <div class="bookmarks-entries ${this.showBookmarks?"":"hidden"}">
                  ${Object.values(this._preparedBookmarks).map(e=>i.d`
                      <div class="flex-container item">
                        <div class="icon-container"></div>
                        <div class="icon-container margin">${this._itemIcon(e)}</div>
                        <div class="title-container">
                          <a href="${e.code}" @click=${t=>this._menuClickHandler(t,e)}> ${this._itemDescription(e)} </a>
                        </div>
                        <fontawesome-icon
                          class="moveb low-op-b icon-small"
                          prefix="fas"
                          name="times"
                          fixed-width
                          @click="${()=>this._bookmarksHandler(e,!1)}"
                        ></fontawesome-icon>
                        <fontawesome-icon
                          class="moveb low-op-b icon-small"
                          prefix="fas"
                          name="angle-up"
                          fixed-width
                          @click="${t=>this._bookmarkMoveHandler(t,e,"up")}"
                        ></fontawesome-icon>
                        <fontawesome-icon
                          class="moveb low-op-b icon-small"
                          prefix="fas"
                          name="angle-down"
                          fixed-width
                          @click="${t=>this._bookmarkMoveHandler(t,e,"down")}"
                        ></fontawesome-icon>
                      </div>
                    `)}
                </div>
              </div>
            `:o.g}
        ${this._preparedItemsIndexByParent.root?i.d`
              <div class="menu ${this.fullWidth?"full-width":""}">
                <div class="flex-container level">
                  <div class="icon-container">
                    <fontawesome-icon class=".icon-small" prefix="fas" name="folder-open" fixed-width></fontawesome-icon>
                  </div>

                  <div class="level-title cursor-pointer" @click="${this._collapseMenu}">${this._preparedItemsTree.root.description}</div>

                  <div class="icon-container">
                    <fontawesome-icon
                      class=".icon-small"
                      prefix="fas"
                      name="${this.showMenu?"minus":"plus"}"
                      @click="${this._collapseMenu}"
                      fixed-width
                    ></fontawesome-icon>
                  </div>
                </div>
                <div class="menu-entries ${this.showMenu?"":"hidden"}">
                  ${this._preparedItemsIndexByParent.root.length&&this._preparedItemsIndexByParent.root.map(e=>i.d`
                      <div class="flex-container item ${this.startLevel==e.code?"selected":""}">
                        <div class="icon-container"></div>
                        <div class="icon-container margin">
                          ${this._itemHasChildrens(e)?this.startLevel==e.code?i.d` <fontawesome-icon class="icon-small" prefix="fas" name="folder-open" fixed-width></fontawesome-icon> `:i.d` <fontawesome-icon class="icon-small" prefix="fas" name="folder" fixed-width></fontawesome-icon> `:this._itemIcon(e)}
                        </div>
                        <div class="title-container">
                          <a href="${e.code}" @click=${t=>this._menuClickHandler(t,e)}> ${e.description||e.text} </a>
                        </div>
                        ${this.handleBookmarks&&!this._itemHasChildrens(e)?i.d`
                              <div class="icon-container ${this._itemIsBookmark(e)?"color-star":"low-op"}">
                                <fontawesome-icon
                                  prefix="fas"
                                  name="star"
                                  fixed-width
                                  @click="${()=>this._bookmarksHandler(e,!this._itemIsBookmark(e))}"
                                ></fontawesome-icon>
                              </div>
                            `:o.g}
                        <div class="number-container">
                          ${this._itemHasChildrens(e)?i.d` ${Object.keys(this._preparedItemsIndexByParent[e.code]).length} `:o.g}
                        </div>
                        <div class="icon-container low-op basis-0">
                          ${this._itemHasChildrens(e)?i.d`
                                <fontawesome-icon
                                  @click=${t=>this._menuClickHandler(t,e)}
                                  class=".icon-small"
                                  prefix="fas"
                                  name="${this.startLevel==e.code?"angle-down":"angle-right"}"
                                  fixed-width
                                ></fontawesome-icon>
                              `:o.g}
                        </div>
                      </div>
                      ${this.startLevel==e.code?this._preparedItemsIndexByParent[this.startLevel].length&&this._preparedItemsIndexByParent[this.startLevel].map(e=>i.d`
                              <div class="flex-container item">
                                <div class="icon-container"></div>
                                <div class="icon-container"></div>
                                <div class="icon-container margin">
                                  ${this._itemHasChildrens(e)?i.d` <fontawesome-icon class="icon-small" prefix="fas" name="folder" fixed-width></fontawesome-icon> `:this._itemIcon(e)}
                                </div>
                                <div class="title-container">
                                  <a href="${e.code}" @click=${t=>this._menuClickHandler(t,e)}> ${e.description||e.text} </a>
                                </div>
                                ${this.handleBookmarks&&!this._itemHasChildrens(e)?i.d`
                                      <div class="icon-container ${this._itemIsBookmark(e)?"color-star":"low-op"}">
                                        <fontawesome-icon
                                          prefix="fas"
                                          name="star"
                                          fixed-width
                                          @click="${()=>this._bookmarksHandler(e,!this._itemIsBookmark(e))}"
                                        ></fontawesome-icon>
                                      </div>
                                    `:o.g}
                                <div class="number-container">
                                  ${this._itemHasChildrens(e)?i.d` ${Object.keys(this._preparedItemsIndexByParent[e.code]).length} `:o.g}
                                </div>
                                <div class="icon-container low-op basis-0">
                                  ${this._itemHasChildrens(e)?i.d`
                                        <fontawesome-icon
                                          @click=${t=>this._menuClickHandler(t,e)}
                                          class=".icon-small"
                                          prefix="fas"
                                          name="angle-right"
                                          fixed-width
                                        ></fontawesome-icon>
                                      `:o.g}
                                </div>
                              </div>
                            `):o.g}
                    `)}
                </div>
              </div>
            `:o.g}
      </div>
    `}constructor(){super(),this.startLevel="root",this._preparedItemsIndexByParent={},this._preparedItemsIndexByObject={},this._preparedBookmarks=[],this._RootItemsOrder=[],this._searchList=[],this._pinnedMenu=!1,this._showFullMenu=!1,this._slicedArray=[]}updated(e){e.has("items")&&this._initMenu(!0),e.has("isopen")&&this.isopen&&this.shadowRoot.querySelector("#search").focus(),e.has("bookmarks")&&this.bookmarks&&this._refreshBookmars()}firstUpdated(){this._initMenu()}_initMenu(e){const t=this._objectClone(this.items);let[s,i,o]=this._prepareItems(t,{},{},"root");this._preparedItemsIndexByParent=i,this._preparedItemsIndexByObject=this._objectClone(o),this._preparedItemsTree={...s,root:{code:0,description:this.customer,icon:"home",show:!0}},e&&this._refreshBookmars()}_bookmarkMoveHandler(e,t,s){let i,o,n,a=[];Object.keys(this._preparedBookmarks).some((e,s)=>{e===t.code&&(o={...t},i=s);let n={...this._preparedBookmarks[e],code:e};a.push(n)}),"down"===s?
// right
i>Object.keys(this._preparedBookmarks).length?n=Object.keys(this._preparedBookmarks).length-1:i>=0&&(n=i+2):(
// left
n=i,i>0&&(n=i-1)),a.splice(i,1,null),a.splice(n,0,o);const r={};a.map(e=>{null!==e&&this._preparedItemsIndexByObject[e.code]&&(r[e.code]=e)}),this._preparedBookmarks=r;const l=Object.values(this._preparedBookmarks).map(e=>e);this.dispatchEvent(new CustomEvent("menuUpdate",{detail:{value:l}}))}_resetBookmarks(){const e=this._objectClone(this._preparedItemsIndexByObject);Object.keys(e).map(t=>{e[t].bookmark=!1}),this._preparedItemsIndexByObject=e}_refreshBookmars(){this._resetBookmarks(),this._prepareBookmarks(),Object.values(this._preparedBookmarks).map(e=>{this._preparedItemsIndexByObject[e.code].bookmark=!0}),this._preparedItemsIndexByObject=this._objectClone(this._preparedItemsIndexByObject)}_prepareBookmarks(){const e=this._objectClone(this.bookmarks),t={};e.map(e=>{this._preparedItemsIndexByObject[e.code]&&(t[e.code]=e,t[e.code].icon=this._preparedItemsIndexByObject[e.code].icon||null)}),this._preparedBookmarks=t}_prepareItems(e={},t={},s={},i,o=null){const n=e;return"root"===i&&(e={},Object.values(JSON.parse(JSON.stringify(n))).map(e=>{e&&e.code&&!this._RootItemsOrder.includes(e.code)&&this._RootItemsOrder.push(e.code)})),Object.values(n).map(n=>{n&&(e[n.code]={code:n.code,description:n.description,icon:n.icon,items:{}},t[i]||(t[i]=[]),t[i].push(n),s[n.code]||(s[n.code]={}),s[n.code]={parentName:i,bookmark:!!this._preparedBookmarks[n.code],icon:n.icon,description:n.description},n.children&&(Object.keys(n.children).map(t=>{const s=n.children[t];e[n.code].items[s.code]=s}),this._prepareItems(e[n.code].items,t,s,n.code,o)))}),[e,t,s]}_menuClickHandler(e,t){if(e.preventDefault(),this._preparedItemsIndexByParent[t.code])return this.startLevel==t.code?void(this.startLevel="root"):void(this.startLevel=t.code);this.dispatchEvent(new CustomEvent("navigate",{detail:{value:t}}))}_menuBackToParentHandler(e){this.startLevel=this._preparedItemsIndexByObject[e].parentName}_bookmarksHandler(e,t){this._preparedItemsIndexByObject[e.code].bookmark=t,this._preparedItemsIndexByObject=this._objectClone(this._preparedItemsIndexByObject),this.dispatchEvent(new CustomEvent(t?"bookmark-add":"bookmark-remove",{detail:{value:e}}))}_itemHasChildrens(e){return this._preparedItemsIndexByParent[e.code]}_itemIsBookmark(e){return this._preparedItemsIndexByObject[e.code].bookmark}_itemDescription(e){return this._preparedItemsIndexByObject[e.code]?this._preparedItemsIndexByObject[e.code].description:""}_itemIcon(e){return e.icon&&"-"!==e.icon&&"--"!==e.icon?e.icon.indexOf("ict:")>-1?i.d` <iron-icon class="icon-small-iron fa-fw" prefix="fas" icon="${e.icon}"></iron-icon> `:e.icon&&"-"!==e.icon&&"--"!==e.icon?i.d` <fontawesome-icon class="icon-small" prefix="fas" name="${e.icon}" fixed-width></fontawesome-icon> `:i.d` <fontawesome-icon class="icon-small" prefix="fas" name="folder" fixed-width></fontawesome-icon> `:i.d` <fontawesome-icon class="icon-small fa-fw" prefix="fas" name="file"></fontawesome-icon> `}_collapseBookmarks(){this.showBookmarks=!this.showBookmarks}_collapseMenu(){this.showMenu=!this.showMenu}_objectClone(e){return JSON.parse(JSON.stringify(e))}_menuSearchHandler(e){const t=e.target.value;this._showFullMenu=!1,this._slicedArray=[],t?(this._searchList=[],Object.keys(this._preparedItemsIndexByObject).some(e=>{const s=this._preparedItemsIndexByObject[e];s.code=e,s.description.toLowerCase().indexOf(t.toLowerCase())>-1&&!this._itemHasChildrens(s)&&this._searchList.push(s)}),this._slicedArray=this._searchList.slice(0,9),this._slicedArray=[...this._slicedArray]):this._searchList=[]}_handlePinnedMenu(){this._pinnedMenu=!this._pinnedMenu,this.dispatchEvent(new CustomEvent("pinnedMenu",{detail:{value:{pinnedMenu:this._pinnedMenu}}}))}}window.customElements.define("six-menu",d)},
/***/"7eJ4":
/***/function(e,t,s){"use strict";
/* harmony import */var i=s("Rukz"),o=(s("KR5w"),s("SMGt"),s("4fQY")),n=s("hR6X");
/* harmony import */
// This element is *not* connected to the Redux store.
class a extends i.b{static get styles(){return[n.D,n.xb]}static get properties(){return{
// Label displayed on title
label:{type:String},
// Icon class
icon:{type:String},class:{type:String},
// "fas" or similar, for fontawesome icons
prefix:{type:String},color:{type:String},useIct:{type:Boolean},useFontawesome:{type:Boolean}}}constructor(){super(),this.prefix="fas",this.set="fa"}render(){return i.d`
      <h3 class="${this.class}" style="${this.color?"color: "+this.color:""}">
        ${this.useFontawesome?i.d` <fontawesome-icon prefix="${this.prefix}" name="${this.icon}" fixed-width></fontawesome-icon> `:o.g}
        ${this.useIct?i.d` <iron-icon icon="ict:${this.icon}"></iron-icon> `:o.g} ${this.label||o.g}
      </h3>
    `}}window.customElements.define("six-title",a)},
/***/CNe1:
/***/function(e,t,s){"use strict";
/* harmony export (binding) */s.d(t,"a",(function(){return o}));
/* harmony import */var i=s("zbnX");class o extends i.a{
// Only render this page if it's actually visible.
shouldUpdate(){return this.active}static get properties(){return{active:{type:Boolean},location:{type:String}}}connectedCallback(){super.connectedCallback(),this.setAttribute("active","")}disconnectedCallback(){super.disconnectedCallback(),this.removeAttribute("active")}}
/***/},
/***/F3b1:
/***/function(e,t,s){"use strict";s.r(t);
/* harmony import */s("Cndk");
/* harmony import */var i=s("Q1Ke"),o=s("jimv"),n=s("vcFs");
/* Import WebpackApp */
// Redux assumes `process.env.NODE_ENV` exists in the ES module build.
// https://github.com/reactjs/redux/issues/2907
window.process={env:{NODE_ENV:"production"}};try{if("serviceWorker"in navigator&&!0===n.d){const e=new i.a("/sw.js");//creato a build-time da webpack
e.addEventListener("waiting",()=>{let t,s;const i=new Promise((e,i)=>{t=e,s=i}),n={type:"info",title:Object(o.a)("COMMON.UPDATE"),message:Object(o.a)("COMMON.UPDATE_AVAILABLE"),position:"top-right",duration:0,okButton:!0,cancelButton:!1,okButtonText:Object(o.a)("COMMON.DO_UPDATE"),cancelButtonText:void 0};document.dispatchEvent(new CustomEvent("new-sx-message",{detail:{message:n,promise:{resolve:t,reject:s}}})),i.then(()=>{e.addEventListener("controlling",()=>{let e=document.createElement("form");e.setAttribute("action",window.location.href),e.setAttribute("method","GET"),document.body.appendChild(e),e.submit()}),e.messageSW({type:"SKIP_WAITING"})})}),e.register().then(e=>{console.log("SW registered with scope:",e.scope)}).catch(e=>{console.error("Registration failed:",e)})}}catch(e){console.warn("ServiceWorker not available:",e.message)}
/***/},
/***/GGEq:
/***/function(e,t,s){"use strict";
/* harmony import */var i=s("Rukz"),o=(s("WKed"),s("+/1h"),s("SMGt"),s("hR6X")),n=s("4fQY"),a=s("N+pe"),r=s("jimv"),l=s("/84T");
/* harmony import */
//https://www.webcomponents.org/element/@polymer/paper-dialog/elements/paper-dialog
class c extends i.b{static get styles(){return[o.i,o.gb]}render(){return i.d`
      <paper-dialog
        id="${this._id}"
        class="${Object(l.a)({sizeSm:"sm"==this.size,sizeMd:"md"==this.size,sizeLg:"lg"==this.size,sizeXl:"xl"==this.size,sizeResponsive:"responsive"==this.size})}"
        @opened-changed="${this._openChanged}"
        ?modal="${this.modal}"
        ?with-backdrop="${!this.modal}"
        ?opened="${this.displayOpen}"
      >
        ${this.modal?n.g:i.d`
              <div style="margin:0px; padding:0px;">
                <fontawesome-icon
                  @click="${this.close}"
                  title="${Object(r.a)("COMMON.CLOSE")}"
                  style="float: right;margin-right: 10px;margin-top: 10px; cursor:pointer"
                  name="times"
                  prefix="fas"
                  fixed-width
                ></fontawesome-icon>
              </div>
            `}
        <div class="dialog-content">
          <div class="col-md 12">
            ${this.title?i.d` <h2>${this.title}</h2> `:n.g} ${this.text?i.d` <span>${this.text}</span> `:n.g}
            <slot name="content"> </slot>
          </div>
        </div>

        ${1==this.hideFooter?"":i.d` <div class="dialog-footer clearfix">
              <slot name="footer">
                <div class="pull-right" style="margin-top:2%">
                  <six-button
                    class="btn-sm btn-danger"
                    icon="times"
                    label="${this.cancelLabel||Object(r.a)("COMMON.CANCEL")}"
                    @click="${this._onCancel}"
                  ></six-button>
                  <six-button class="btn-sm btn-success" icon="check" label="${Object(r.a)("COMMON.CONFIRM")}" @click="${this._onConfirm}"></six-button>
                </div>
              </slot>
            </div>`}
      </paper-dialog>
    `}
/* ************** START: STRUTTURA BASE PAGINA ************** */static get properties(){return{modal:{type:Boolean},
//implies no-cancel-on-outside-click, no-cancel-on-esc-key and with-backdrop
text:{type:String},title:{type:String},size:{type:String},
//sm, md, lg
displayOpen:{type:Boolean},noAutoclose:{type:Boolean},
//disable auto close modal on confirm/cancel
cancelLabel:{type:String},open:{attribute:!1},
//open modal
close:{attribute:!1},
//close modal
isOpen:{attribute:!1},hideFooter:{type:Boolean}};
/* slots available for replacement: 'footer', 'content' */}get isOpen(){return this._dialog&&this._dialog.opened||!1}set isOpen(e){//cannot set
}constructor(){super(),this._id=Object(a.l)()}firstUpdated(){this._dialog=this.shadowRoot.querySelector("#"+this._id)}
/* ************** END: STRUTTURA BASE PAGINA ************** */open(){this._dialog.open()}close(){this._dialog.close()}_onConfirm(){this.dispatchEvent(new CustomEvent("confirm",{detail:{value:{}}})),this.noAutoclose||this.close()}_onCancel(){this.dispatchEvent(new CustomEvent("cancel",{detail:{value:{}}})),this.noAutoclose||this.close()}_openChanged(e){e.stopPropagation(),this.dispatchEvent(new CustomEvent("opened-changed",{detail:{value:{opened:this.isOpen}}}))}}window.customElements.define("six-modal",c)},
/***/"LAU/":
/***/function(e,t,s){"use strict";
/* harmony import */var i=s("Rukz"),o=s("4fQY"),n=(s("GGEq"),s("7eJ4"),s("hR6X"));
/* harmony import */class a extends i.b{static get styles(){return[n.hb]}static get properties(){return{showLoading:{type:Boolean},asModal:{type:Boolean},small:{type:Boolean}}}constructor(){super(),this._hidingPromises=[]}render(){return i.d` ${this.showLoading?i.d` <span class="loader"></span> `:o.g}`}show(e){if(this.showLoading=!0,e)return this._hidingPromises.push(e),e.finally(()=>{this._hidingPromises.pop(),this.hide()}),e}hide(){0===this._hidingPromises.length&&(this.showLoading=!1)}}window.customElements.define("six-new-spinner",a)},
/***/"N+pe":
/***/function(e,t,s){"use strict";
/* harmony export (binding) */s.d(t,"g",(function(){return l})),
/* harmony export (binding) */s.d(t,"s",(function(){return c})),
/* harmony export (binding) */s.d(t,"c",(function(){return d})),
/* unused harmony export dateTmzHTML */
/* harmony export (binding) */s.d(t,"e",(function(){return h})),
/* unused harmony export getPriorityColorStyleHTML */
/* harmony export (binding) */s.d(t,"b",(function(){return u})),
/* unused harmony export dateTmz */
/* harmony export (binding) */s.d(t,"d",(function(){return p})),
/* harmony export (binding) */s.d(t,"n",(function(){return m})),
/* harmony export (binding) */s.d(t,"i",(function(){return b})),
/* harmony export (binding) */s.d(t,"t",(function(){return g})),
/* harmony export (binding) */s.d(t,"o",(function(){return f})),
/* harmony export (binding) */s.d(t,"p",(function(){return v})),
/* harmony export (binding) */s.d(t,"m",(function(){return _})),
/* harmony export (binding) */s.d(t,"k",(function(){return w})),
/* unused harmony export getSerialKitPriorityLevel */
/* unused harmony export getPriorityLevelsAsMap */
/* harmony export (binding) */s.d(t,"j",(function(){return k})),
/* harmony export (binding) */s.d(t,"l",(function(){return y})),
/* harmony export (binding) */s.d(t,"r",(function(){return x})),
/* harmony export (binding) */s.d(t,"q",(function(){return O})),
/* unused harmony export playInfoSound */
/* harmony export (binding) */s.d(t,"f",(function(){return C})),
/* harmony export (binding) */s.d(t,"h",(function(){return $})),
/* unused harmony export objectIsNotEmpty */
/* harmony export (binding) */s.d(t,"a",(function(){return E}));
/* unused harmony export getPayloadGqlFilter */
/* unused harmony export parseUniversalDate */
/* harmony import */var i=s("4fQY"),o=s("jimv"),n=s("72OT"),a=s.n(n);
/* harmony import */s("OcfT");
//altrimenti non vengono inseriti nel bundle
const r={priorityValues:{0:"PR_STANDARD",10:"PR_PRIORITY",20:"PR_URGENT",30:"PR_LIFESAVER"},priorityThreshold:20,priorityLevels:{PR_STANDARD:{level:0,description:"Standard",production_time:604800,alert_time:518400,bg_color:"rgba(255,206,84,0.4)"},PR_PRIORITY:{level:10,description:"Prioritario",production_time:604800,alert_time:518400,bg_color:"rgba(245, 161, 4, 0.69);"},PR_URGENT:{level:20,description:"Urgente",production_time:604800,alert_time:518400,bg_color:"rgba(237,85,101,0.4)"},PR_LIFESAVER:{level:30,description:"Salvavita",production_time:604800,alert_time:518400,bg_color:"rgba(171,146,236,0.4)"}}},l=()=>navigator.language||navigator.userLanguage||"en-us",c=e=>a.a.locale(e)
/****************************************************************************  HTML *****************************************************************/
/**
 * Date formatter. Ignores timezone.
 * @param {string | number | Date} date - Valid date
 * @param {string} [format] - custom date format (optional)
 */,d=Object(i.e)((e,t=null)=>s=>{const i=t||a.a.localeData().longDateFormat("L");let o=e?a()(e).format(i):void 0;s.setValue(o)}),h=(Object(i.e)((e,t=null)=>s=>{const i=a.a.tz.guess(),o=t||a.a.localeData().longDateFormat("L");let n=e?a.a.tz(e,i).format(o):void 0;s.setValue(n)}),Object(i.e)((e,t=null)=>s=>{const i=a.a.tz.guess(),o=t||a.a.localeData().longDateFormat("L")+" HH:mm";let n=e?a.a.tz(e,i).format(o):void 0;s.setValue(n)})),u=(Object(i.e)((e,t,s=r)=>i=>{if(null!=e&&s&&Object.keys(s).length){
// Priorità a livelli
let t=s.priorityValues[e];i.setValue(s.priorityLevels[t].bg_color)}else
// Priorità standard T/F
t?i.setValue("rgba(237,85,101,0.4)"):i.setValue("inherit")}),(e,t=null)=>{const s=t||a.a.localeData().longDateFormat("L");return e?a()(e).format(s):void 0}),p=(e,t=null)=>{const s=a.a.tz.guess(),i=t||a.a.localeData().longDateFormat("L")+" HH:mm";return e?a.a.tz(e,s).format(i):void 0},m=e=>Object(o.a)("STATUS."+e),b=(e,t)=>{if(!e||!t)return e;let s;return t.split(".").some(t=>{if(void 0===e||null==e[t])return s=void 0,!0;s=e[t],e=e[t]}),s},g=(e,t,s)=>{if(t){let i=t.split(".");i.forEach((t,o)=>{o==i.length-1?e[t]=s:(null==e[t]&&(e[t]={}),e=e[t])})}return e},f=e=>{let t=typeof e;return"object"===t&&Object.prototype.toString.call(e).match(/array/i)&&(t="array"),t},v=Object(i.e)((e,t)=>s=>{if(!e){const e=s.committer.name;return void s.committer.element.removeAttribute(e)}let o=b(e,t);if(null==o&&s instanceof i.a){if(o!==s.value){const e=s.committer.name;s.committer.element.removeAttribute(e)}}else s.setValue(o)}),_=e=>{switch(e){case"NEW":return"file";case"ACCD":return"check";case"C":return"thumbs-up";case"CDS":return"spinner";
//non va
case"D":return"dolly";case"LOST":return"exclamation";case"W":return"building";case"WIP":return"hourglass";case"SW":return"hand-sparkles";case"NC":return"dumpster";case"RI":return"recycle";case"RSM":return"hospital";case"T":return"user-tie";case"SHPBLDEP":return"warehouse";case"SHPBLW":return"box-open";case"SHPBLD":return"truck";case"PCW":return"pallet";case"SD":return"truck";case"SWA":return"suitcase";case"SL":return"trailer";case"DD":return"bug";case"DREP":return"ban";case"DWA":return"bug";case"ST":return"temperature-high";case"U":return"bacterium";case"N":
// new
return"file";case"INCOMPLETE":return"minus-circle";case"CONSUMED":return"box-open";case"CONTAINER":return"business-time";case"STER_CONTRACT_WORK":return"file-invoice-dollar";case"ACCEPTED_CLEANED":return"shopping-basket";case"ACCEPTED":return"vote-yea";case"PACKED":case"PACKAGED":case"P":
// Confezionato
return"box";case"STERILIZED":return"hourglass-end";case"F":return"square-full";case"L":return"soap";case"WASHED":return"shower";case"PARTIAL_WASHED":return"wind";case"PARTIAL_CONTAINER_W":case"CONTAINER_WASH":case"CONTAINER_AUTO":return"shopping-cart";case"PARTIAL_WASHED_w":return"fill-drip";case"ASSOCIATED":case"ASSOCIATED_WASH":case"ASSOCIATED_AUTO":case"PARTIAL_ASSOCIATED_W":return"business-time";case"REORDERED":return"sort-amount-up-alt";case"INVALID":case"INVALIDATED":return"exclamation-triangle";case"SHIPPABLE":return"boxes";case"SENT":case"S":
// spedito
return"shipping-fast";case"AUTOCLAVE":return"tachometer-alt";case"USED":return"box-open";case"COLLECTED":return"atom";
// ORDINI
case"TO_DISPATCH":return"clipboard-list";case"DISPATCHABLE":return"check";case"DISPATCHED":return"truck";case"CANCELED":return"ban";case"TO_CONFIRM":return"pause-circle";
//NUOVI STATI JMS
case"LOADED":return"truck-loading";case"DIRTY":return"disease";case"TRANSIT":return"route";case"CHECKOUT":return"sign-out-alt";case"CHECKIN":return"sign-in-alt";case"UNLOADED":return"people-carry";case"NOT_RECEIVED":return"exclamation-circle";case"RDY_TO_SEND_SUP":return"pallet";case"RECEIVED":return"store-alt";case"RET_TO_SUP":case"RDY_TO_SND_CUS":return"shipping-fast";case"RDY_TO_RECEIVE":return"envelope-open";case"STER_CHECKED":return"check-double";case"WAREHOUSE":return"warehouse";case"STORED":return"store";case"DELIVERED":return"truck";case"NOT_ACCEPTED":return"ban";case"TAKEN":return"box-open";case"EXPIRED":return"exclamation-triangle";case"AVAILABLE":return"box-open";case"CONTAINS_KIT":return"toolbox";case"CONTAINS_CONTAINER":return"container-storage";case"DECONTAMINATOR":return"biohazard";case"WASHING_EQUIPMENT":return"wind";case"OPERATOR":return"male";case"CONTAINER_FULL":return"box";case"CONTAINER_WASHED":return"shower";case"DIRTY_DELIVERED":return"shipping-fast";case"DIRTY_COLLECTED":return"atom";case"E":
// Rientrato
return"arrow-alt-circle-left";case"A":
// Dismesso
return"user-slash";case"TO_REPAIR":return"tools";
// inventario
case"OPEN":return"envelope-open";case"CLOSED":return"envelope";case"PROCESSING":return"spinner";case"DEPOT":case"WARDROBE":return"warehouse";case"SENT_WARDROBE":return"shipping-fast";case"PENDING":return"pause-circle";case"SENT_TO_SAP":return"share-square";case"SAP_CLOSED":return"check-circle";case"N_CONFIRMED":return"window-close";case"ACC_WARD":return"check-square";case"SENT_WARD":return"truck";case"SENT_DEPOT":return"pallet";case"ACC_DEST":return"dolly-flatbed";default:return e}},w=(e,t,s=r)=>{if(null!=e&&s&&Object.keys(s).length){
// Priorità a livelli
let t=s.priorityValues[e];return s.priorityLevels[t].bg_color}
// Priorità standard T/F
return t||"T"===t?"rgba(237,85,101,0.4)":"inherit"},k=e=>{let t=(e=>{let t={};for(let s in e.priorityValues)t[s]=e.priorityLevels[e.priorityValues[s]];return t})(e),s=[];for(let e in t)s.push(t[e]);return s},y=()=>{let e="",t="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";for(let s=0;s<10;s++)e+=t.charAt(Math.floor(Math.random()*t.length));return e},x=()=>new Audio("assets/sounds/read.mp3").play(),O=()=>new Audio("assets/sounds/error.mp3").play(),C=()=>{i.l.clear()},$=e=>m(e),E=class{constructor({namespace:e,fallback:t}){this._namespace=e,this._fallback=t||"COMMON"}do(e,t){return Object(o.b)(this._namespace,this._fallback,e,t)}}},
/***/OLad:
/***/function(e,t,s){"use strict";
/* harmony import */var i=s("Rukz"),o=s("hR6X"),n=s("jimv");
/* harmony import */class a extends i.b{static get styles(){return[o.a]}static get properties(){return{page:{type:String},bookmarks:{type:Object},orientation:{type:String},menuByObject:{type:Object}}}constructor(){super()}render(){return i.d`
      <nav class="toolbar-list" sticky>
        <vaadin-tabs theme="equal-width-tabs" orientation="${this.orientation}">
          <vaadin-tab ?selected="${"home"===this.page}" class="tabs" @click="${()=>this._onClick("?home")}">
            <fontawesome-icon prefix="fas" name="home"></fontawesome-icon>
            <span>${Object(n.a)("COMMON.HOME_PAGE")}</span>
          </vaadin-tab>
          ${this.bookmarks.map(e=>i.d`
              <vaadin-tab ?selected="${this.page===e.code}" class="tabs" @click="${()=>this._onClick(e.code)}">
                ${this._itemIcon(e)}
                <span>${e.description}</span>
              </vaadin-tab>
            `)}
        </vaadin-tabs>
      </nav>
    `}_itemIcon(e){return e.icon=this.menuByObject&&this.menuByObject[e.code]&&this.menuByObject[e.code].icon?this.menuByObject[e.code].icon:e.icon,e.icon&&"-"!==e.icon&&"--"!==e.icon?e.icon.indexOf("ict:")>-1?i.d` <iron-icon class="icon-small-iron fa-fw" prefix="fas" icon="${e.icon}"></iron-icon> `:e.icon&&"-"!==e.icon&&"--"!==e.icon?i.d` <fontawesome-icon class="icon-small" prefix="fas" name="${e.icon}" fixed-width></fontawesome-icon> `:i.d` <fontawesome-icon class="icon-small" prefix="fas" name="folder" fixed-width></fontawesome-icon> `:i.d` <fontawesome-icon class="icon-small fa-fw" prefix="fas" name="file"></fontawesome-icon> `}_onClick(e){this.dispatchEvent(new CustomEvent("tabSelect",{detail:{value:e}}))}}window.customElements.define("tab-menu",a)},
/***/RXvc:
/***/function(e,t,s){"use strict";
/* harmony import */var i=s("Rukz"),o=s("Pg2j"),n=s("jimv");
/* harmony import */const a=new o.a;class r extends i.b{constructor(){super()}static get properties(){return{position:{type:String}}}updated(e){e.has("position")&&this.position&&a.config({position:this.position})}connectedCallback(){super.connectedCallback(),document.addEventListener("new-sx-message",l)}disconnectedCallback(){document.removeEventListener("new-sx-message",l),super.disconnectedCallback()}
/**--------------------------- */}function l(e){e.stopPropagation(),a.create({title:e.detail.message.title,icon:e.detail.message.icon,message:e.detail.message.message,duration:e.detail.message.duration,type:e.detail.message.type,okButton:e.detail.message.okButton,cancelButton:e.detail.message.cancelButton,okButtonText:e.detail.message.okButtonText||Object(n.a)("COMMON.OK"),cancelButtonText:e.detail.message.cancelButtonText||Object(n.a)("COMMON.CANCEL"),data:{promise:e.detail.promise,data:e.detail.data},template:e.detail.message.template,customStyle:e.detail.message.customStyle,onOkButtonClick:e=>{e.hide();(0,e.data.promise.resolve)(e.data.data||!0),delete e.data},onCancelButtonClick:e=>{e.hide();(0,e.data.promise.reject)(e.data.data||!1),delete e.data},onDismiss:e=>{if(e.data){(0,e.data.promise.resolve)(e.data.data||!0),delete e.data}}})}window.customElements.define("six-message",r)},
/***/Uolk:
/***/function(e,t,s){"use strict";
/* harmony import */var i=s("Rukz"),o=s("hR6X"),n=(s("O5j2"),s("oDC5"),s("1UqG"),s("hSgB"),s("N+pe")),a=s("jimv");
/* harmony import */class r extends i.b{static get styles(){return[o.D,o.i]}render(){switch(this.type){case"number":return i.d`
          <dom-module id="custom-textfield" theme-for="vaadin-text-field">
            <template>
              <style>
                [part~='input-field'] {
                  background-color: #fff !important;
                }

                :host([invalid]) [part='input-field'] {
                  background-color: #fff !important;
                }
              </style>
            </template>
          </dom-module>

          <vaadin-number-field
            id="${this._id}"
            name="${this._id}"
            label="${this.label||""}"
            placeholder="${this.placeholder||""}"
            style="${this.style||"width:100%; height:inherit; padding:0px"}"
            ?required="${this.required}"
            .error-message="${this.errormessage}"
            .helperText="${this.helpertext||""}"
            .maxlength="${this.maxlength}"
            .minlength="${this.minlength}"
            ?disabled="${this.disabled||!1}"
            ?readonly="${this.readonly}"
            @change="${this._oninputchange}"
            @input="${this._onKeyPress}"
            title="${this.title}"
            type="number"
            ?clear-button-visible="${!this.hasControls}"
            ?has-controls="${this.hasControls}"
          >
            <div slot="prefix">
              <slot name="prefix"></slot>
            </div>
            <div slot="suffix">
              <slot name="suffix"></slot>
            </div>
          </vaadin-number-field>
        `;case"email":return i.d`
          <dom-module id="custom-textfield" theme-for="vaadin-text-field">
            <template>
              <style>
                [part~='input-field'] {
                  background-color: #fff !important;
                }

                :host([invalid]) [part='input-field'] {
                  background-color: #fff !important;
                }
              </style>
            </template>
          </dom-module>

          <vaadin-email-field
            id="${this._id}"
            name="${this._id}"
            label="${this.label||""}"
            placeholder="${this.placeholder||""}"
            style="${this.style||"width:100%; height:inherit; padding:0px"}"
            ?required="${this.required}"
            .error-message="${this.errormessage}"
            .helperText="${this.helpertext||""}"
            .maxlength="${this.maxlength}"
            .minlength="${this.minlength}"
            ?disabled="${this.disabled||!1}"
            ?readonly="${this.readonly}"
            @change="${this._oninputchange}"
            @input="${this._onKeyPress}"
            title="${this.title}"
            type="email"
            clear-button-visible
          >
            <div slot="prefix">
              <slot name="prefix"></slot>
            </div>
            <div slot="suffix">
              <slot name="suffix"></slot>
            </div>
          </vaadin-email-field>
        `;case"password":return i.d`
          <dom-module id="custom-textfield" theme-for="vaadin-text-field">
            <template>
              <style>
                [part~='input-field'] {
                  background-color: #fff !important;
                }

                :host([invalid]) [part='input-field'] {
                  background-color: #fff !important;
                }
              </style>
            </template>
          </dom-module>

          <vaadin-password-field
            id="${this._id}"
            label="${this.label||""}"
            name="${this._id}"
            placeholder="${this.placeholder||""}"
            style="${this.style||"width:100%; height:inherit; padding:0px"}"
            ?required="${this.required}"
            .error-message="${this.errormessage}"
            .helperText="${this.helpertext||""}"
            .maxlength="${this.maxlength}"
            .minlength="${this.minlength}"
            ?disabled="${this.disabled||!1}"
            ?readonly="${this.readonly}"
            @change="${this._oninputchange}"
            @input="${this._onKeyPress}"
            title="${this.title}"
            type="password"
            clear-button-visible
          >
            <div slot="prefix">
              <slot name="prefix"></slot>
            </div>
            <div slot="suffix">
              <slot name="suffix"></slot>
            </div>
          </vaadin-password-field>
        `;default:return i.d`
          <dom-module id="custom-textfield" theme-for="vaadin-text-field">
            <template>
              <style>
                [part~='input-field'] {
                  background-color: #fff !important;
                }

                :host([invalid]) [part='input-field'] {
                  background-color: #fff !important;
                }
              </style>
            </template>
          </dom-module>

          <vaadin-text-field
            id="${this._id}"
            name="${this._id}"
            label="${this.label||""}"
            placeholder="${this.placeholder||""}"
            style="${this.style||"width:100%; height:inherit; padding:0px"}"
            ?required="${this.required}"
            .error-message="${this.errormessage}"
            .helperText="${this.helpertext||""}"
            .maxlength="${this.maxlength}"
            .minlength="${this.minlength}"
            ?disabled="${this.disabled||!1}"
            ?readonly="${this.readonly}"
            @change="${this._oninputchange}"
            @input="${this._onKeyPress}"
            title="${this.title}"
            type="text"
            clear-button-visible
          >
            <div slot="prefix">
              <slot name="prefix"></slot>
            </div>
            <div slot="suffix">
              <slot name="suffix"></slot>
            </div>
          </vaadin-text-field>
        `}}static get properties(){return{label:{type:String},placeholder:{type:String},value:{type:String},style:{type:String},required:{type:Boolean},errormessage:{type:String},helpertext:{type:String},maxlength:{type:Number},minlength:{type:Number},disabled:{type:Boolean},readonly:{type:Boolean},type:{type:String},checkValidity:{attribute:!1},validate:{attribute:!1},reset:{attribute:!1},hasControls:{type:Boolean},step:{type:String},min:{type:String},max:{type:String},pattern:{type:String},getValueAsNumber:{type:Boolean},noAutoAction:{type:Boolean},autoFocus:{type:Boolean}}}get value(){return this.getValueAsNumber&&"number"==this.type?Number(this._value):this._value}set value(e){const t=this._value;this._value=e,this.requestUpdate("value",t)}constructor(){super(),this._id=Object(n.l)(),this.style="",//private property to keep a 1:1 relashionship between the value
//of the vaadin component and the value of the six component
this._value=""}firstUpdated(){this._element=this.shadowRoot.querySelector("#"+this._id),this.errorMessage||(this._noErrorMessage=!0),this.type&&"number"==this.type&&(null!=this.step&&this._element.setAttribute("step",Number(this.step)),null!=this.min&&this._element.setAttribute("min",Number(this.min)),null!=this.max&&this._element.setAttribute("max",Number(this.max))),this._getDefaultMessage(),this.checkValidity=()=>this._element.checkValidity(),this.validate=()=>{this._element.validate(),this._getDefaultMessage()},this.reset=()=>{this._value="",this._element.clear(),//set this._element.value = ''
this._element.invalid=!1,this._element.removeAttribute("invalid"),this._getDefaultMessage()},this.autoFocus&&this.sixFocusElement()}updated(e){if((e.has("max")||e.has("min"))&&this.type&&"number"==this.type&&(null!=this.step&&this._element.setAttribute("step",Number(this.step)),null!=this.min&&this._element.setAttribute("min",Number(this.min)),null!=this.max&&this._element.setAttribute("max",Number(this.max))),e.has("pattern")&&null!=this.pattern&&(this._element.pattern=this.pattern),e.has("value")&&(this._element.value=this._value,!this.noAutoAction)){const e={currentTarget:{value:this.value}};this._oninputchange(e),this._onKeyPress(e)}}sixFocusElement(e=0){if(!this._element||!this._element.shadowRoot||null==this._element.shadowRoot.querySelector("input"))return e<10?this.updateComplete.then(()=>this.sixFocusElement(e+1)):void 0;this._element.shadowRoot.querySelector("input").focus()}_getDefaultMessage(){if(this._noErrorMessage){switch(this._element.getAttribute("type")){case"number":this._element.invalid&&null!=this._element.value&&""!=this._element.value&&this.pattern&&this.pattern.test(this._element.value)?this._element.errorMessage=Object(a.a)("COMMON.INVALID_NUMBER"):!this.required||""!=this._element.value&&null!=this._element.value?this._element.errorMessage="":this._element.errorMessage=Object(a.a)("COMMON.REQUIRED");break;case"email":this._element.invalid&&null!=this._element.value&&""!=this._element.value&&this.pattern&&this.pattern.test(this._element.value)?this._element.this._element.errorMessage=Object(a.a)("COMMON.INVALID_EMAIL_ADDRESS"):!this.required||""!=this._element.value&&null!=this._element.value?this._element.errorMessage="":this._element.errorMessage=Object(a.a)("COMMON.REQUIRED");break;case"password":this._element.invalid&&null!=this._element.value&&""!=this._element.value&&this.pattern&&this.pattern.test(this._element.value)?this._element.errorMessage=Object(a.a)("COMMON.INVALID_PASSWORD"):!this.required||""!=this._element.value&&null!=this._element.value?this._element.errorMessage="":this._element.errorMessage=Object(a.a)("COMMON.REQUIRED");break;case"text":this._element.invalid&&null!=this._element.value&&""!=this._element.value&&this.pattern&&this.pattern.test(this._element.value)?this._element.errorMessage=Object(a.a)("COMMON.INVALID_TEXT"):!this.required||""!=this._element.value&&null!=this._element.value?this._element.errorMessage="":this._element.errorMessage=Object(a.a)("COMMON.REQUIRED");break;default:this._element.errorMessage=""}}}_onKeyPress(e){let t=e.currentTarget.value;this.getValueAsNumber&&"number"==this.type&&(t=Number(t)),//since the value comes from the vaadin component we dont need to trigger template rendering to
//update the view, we only need to make sure the six component has the updated value
this._value=t,this.dispatchEvent(new CustomEvent("key-press",{detail:{value:t}})),setTimeout(()=>{this._getDefaultMessage()})}_oninputchange(e){let t=e.currentTarget.value;t&&this.getValueAsNumber&&"number"==this.type&&(t=Number(t)),//since the value comes from the vaadin component we dont need to trigger template rendering to
//update the view, we only need to make sure the six component has the updated value
this._value=t,this.dispatchEvent(new CustomEvent("change",{detail:{value:t}})),setTimeout(()=>{this._getDefaultMessage()})}}window.customElements.define("six-input",r)},
/***/WKed:
/***/function(e,t,s){"use strict";
/* harmony import */var i=s("Rukz"),o=(s("SMGt"),s("hR6X")),n=s("4fQY");
/* harmony import */
// This element is *not* connected to the Redux store.
class a extends i.b{static get styles(){return[o.M]}render(){return i.d`
      <button
        class="btn ${this.class||"btn-sm btn-default"}"
        type="${this.type||"button"}"
        @click="${e=>this._onClick(e)}"
        ?disabled="${this._isDisabled()}"
        style="${(this.style||"")+(this.color?";background-color:"+this.color:"")}"
      >
        ${this.useIct&&this.icon?i.d` <iron-icon @click="${this._onClick}" icon="ict:${this.icon}" class="${this.label?"icon-margin-right":""}"></iron-icon> `:this.icon?i.d`
              <fontawesome-icon
                @click="${this._onClick}"
                prefix="${this.prefix}"
                name="${this.icon}"
                class="${this.label?"icon-margin-right":""}"
                fixed-width
              ></fontawesome-icon>
            `:n.g}
        ${this.label}
      </button>
    `}
/* ************** START: STRUTTURA BASE PAGINA ************** */static get properties(){return{label:{type:String},icon:{type:String},class:{type:String},disabled:{type:Boolean},_forceDisabled:{type:Boolean,attribute:!1},color:{type:String},prefix:{type:String},useIct:{type:Boolean},type:{type:String},style:{type:String},model:{type:Object}}}constructor(){super(),this.disabled=!1,this.prefix="fas",this._disablingPromises=[]}
/* ************** END: STRUTTURA BASE PAGINA ************** */_isDisabled(){return this.disabled||this._forceDisabled}_onClick(e){e.stopPropagation(),e.preventDefault(),this._isDisabled()||this.dispatchEvent(new CustomEvent("click",{detail:{value:{model:this.model},disable:e=>(this._forceDisabled=!0,this._disablingPromises.push(e),e.finally(()=>{this._disablingPromises.pop(),0===this._disablingPromises.length&&(this._forceDisabled=!1)}),e)}}))}}window.customElements.define("six-button",a)},
/***/dVtU:
/***/function(e,t,s){"use strict";
// EXTERNAL MODULE: ./node_modules/lit-element/lit-element.js?babel-target=es6 + 3 modules
var i=s("Rukz"),o=s("hR6X");
// EXTERNAL MODULE: ./styles/serviziospedalieri/styles.js?babel-target=es6 + 38 modules
s("ASvk"),s("JZ/u"),s("7eJ4");
// CONCATENATED MODULE: ./src/components/app-icons.js?babel-target=es6
i.d`
  <svg width="24" height="24" viewBox="0 0 24 24"><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path></svg>
`,i.d`
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" /></g>
  </svg>
`;const n=i.d`<svg viewBox="0 0 24 24"><g><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></path></g></svg>`;i.d`
  <svg width="36" height="36" viewBox="0 0 24 24">
    <g>
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
      />
    </g>
  </svg>
`,i.d`
  <svg viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
    />
  </svg>
`,i.d`
  <svg viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
    />
  </svg>
`,i.d`
  <svg viewBox="0 0 24 24">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
`;
// CONCATENATED MODULE: ./src/components/search-input-decorator.js?babel-target=es6
class a extends i.b{static get styles(){return[o.v]}render(){const{_focused:e}=this;return i.d`
      <div class="icon">${n}</div>
      <div class="decorator" ?focused="${e}">
        <slot id="inputSlot" name="input"></slot>
      </div>
      <slot name="button"></slot>
    `}static get properties(){return{_focused:{type:Boolean}}}firstUpdated(){
// Do all setup work after the first render.
// Assume the input is in the slot
this._input=this.shadowRoot.querySelector("#inputSlot").assignedNodes({flatten:!0})[0],this._input.addEventListener("focus",()=>this._focused=!0),this._input.addEventListener("blur",()=>this._focused=!1)}}window.customElements.define("search-input-decorator",a);
// CONCATENATED MODULE: ./src/components/speech-mic.js?babel-target=es6
class r extends i.b{static get styles(){return[o.Bb]}render(){return i.d`
      <div class="ring1"></div>
      <div class="ring2"></div>
      <button title="Search by voice" @click="${()=>this.toggle()}">
        <svg viewBox="0 0 24 24">
          <g>
            <path
              d="M12,14c1.7,0,3-1.3,3-3l0-6c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3v6C9,12.7,10.3,14,12,14z M17.3,11c0,3-2.5,5.1-5.3,5.1c-2.8,0-5.3-2.1-5.3-5.1H5c0,3.4,2.7,6.2,6,6.7V21h2v-3.3c3.3-0.5,6-3.3,6-6.7H17.3z"
            ></path>
          </g>
        </svg>
      </button>
    `}static get properties(){return{transcript:{type:String},completeTranscript:{type:String},language:{type:String},continuous:{type:Boolean},interimResults:{type:Boolean},_recognizing:{type:Boolean,attribute:"recognizing",reflect:!0}}}constructor(){super(),this.language=window.navigator.language}firstUpdated(){window.webkitSpeechRecognition?(this._recognition=new webkitSpeechRecognition,this._recognition.continuous=this.continuous,this._recognition.interimResults=this.interimResults,this._recognition.lang=this.language,this._recognition.onstart=this._onStart.bind(this),this._recognition.onend=this._onEnd.bind(this),this._recognition.onresult=this._onResult.bind(this),this._recognition.onerror=this._onError.bind(this)):this.style.display="none"}toggle(){this._recognition&&(this._recognizing?this._recognition.stop():this._recognition.start())}stop(){this._recognition&&this._recognition.stop()}_onStart(){this._recognizing=!0}_onEnd(){this._recognizing=!1}_onResult(e){let t,s,i="";for(let o,n=0;o=e.results[n];n++)t=o[0]&&o[0].transcript||"",i+=t,s=o.isFinal;this.transcript=t,this.completeTranscript=i,this.dispatchEvent(new CustomEvent("result",{detail:{results:e.results,transcript:t,completeTranscript:i,isFinal:s}})),s&&this.stop()}_onError(e){console.log(e)}}window.customElements.define("speech-mic",r);
// EXTERNAL MODULE: ./node_modules/lit-html/lit-html.js?babel-target=es6 + 1 modules
var l=s("4fQY");
// CONCATENATED MODULE: ./src/components/six-notification.js?babel-target=es6
class c extends i.b{static get styles(){return[]}render(){return this.showIcon?i.d` <six-title icon="bell" useFontawesome></six-title> `:l.g}static get properties(){return{notificationWebsocketUrl:{type:String},username:{type:String},role:{type:String},showIcon:{type:Boolean},workstationCode:{type:String}}}constructor(){super()}disconnectedCallback(){super.disconnectedCallback(),this.closeWebsocket(),clearInterval(this._interval)}updated(e){e.has("notificationWebsocketUrl")&&(this.notificationWebsocketUrl?this.openWebsocket():this.closeWebsocket()),this._websocket&&this._websocket.readyState==this._websocket.OPEN&&(e.has("username")||e.has("role")||e.has("workstationCode"))&&this._registerDefaultChannels()}
/*********************************************************************************** */openWebsocket(){if(!this.notificationWebsocketUrl)throw Error("url property is required");this.closeWebsocket(),//chiudo vecchia WS caso mai fosse aperta
this._websocket=new WebSocket(this.notificationWebsocketUrl),//url passato da app-steriliza
this._websocket.onopen=this._onOpen.bind(this),this._websocket.onclose=this._onClose.bind(this),this._websocket.onmessage=this._onMessage.bind(this),this._websocket.onerror=this._onError.bind(this),this._interval=setInterval(()=>{this._websocket&&this._websocket.readyState==this._websocket.OPEN&&(
//se è connected allora ping
this._websocket.send(JSON.stringify({type:"ping"})),// eslint-disable-next-line no-console
console.log("ping ws "+JSON.stringify(this._websocket)))},15e3)}closeWebsocket(){this._websocket&&(this._websocket.close(),this._websocket=null)}_onOpen(){this._registerDefaultChannels(),// eslint-disable-next-line no-console
console.log("Connection opened with websocket "+this.notificationWebsocketUrl)}_onClose(){
// eslint-disable-next-line no-console
console.log("Connection closed with websocket "+this.notificationWebsocketUrl)}_onError(){
// eslint-disable-next-line no-console
console.log("connection error"),this.closeWebsocket()}_onMessage(e){let t,s,i=JSON.parse(e.data);const o=new Promise((e,i)=>{t=e,s=i});if("ping"!=i.type){if("notifymessage"==i.type){const e=JSON.parse(i.metadata||null);if(e&&e.notificationTriggerUsername!==this.username)return}document.dispatchEvent(new CustomEvent("new-sx-message",{detail:{message:{type:i.level||"info",icon:{prefix:"fas",icon:i.icon},message:i.from+": "+i.msg,okButton:!0,okButtonText:"OK"},promise:{resolve:t,reject:s},data:i}})),o.then(e=>this.dispatchEvent(new CustomEvent("notification-read",{detail:{value:e}})))}}_registerDefaultChannels(){this.username&&this._websocket.send(JSON.stringify({project:this.username})),this.role&&this._websocket.send(JSON.stringify({project:this.role})),this.workstationCode&&this._websocket.send(JSON.stringify({project:"notify_"+this.workstationCode}))}}window.customElements.define("six-notification",c);
// EXTERNAL MODULE: ./src/components/six-tooltip-content.js?babel-target=es6
s("jrL5"),s("SMGt");
// EXTERNAL MODULE: ./node_modules/fontawesome-icon/fontawesome-icon.js?babel-target=es6
var d=s("jimv");
// CONCATENATED MODULE: ./src/components/workstation-selection.js?babel-target=es6
class h extends i.b{static get styles(){return[o.Db,o.D,i.c`
        .dropdown {
          position: relative;
          display: inline-block;
        }

        .dropdown-button {
          background-color: var(--app-primary-color);
          color: white;
          border-radius: 8px;
          cursor: pointer;
          font-size: 13px;
          font-weight: 600;
          padding: 0 12px;
          height: 30px;
          border: none;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
          transition: all 0.15s ease;
        }

        .dropdown-button:focus {
          outline: none;
          filter: brightness(1.1);
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        }

        .dropdown-button:hover {
          filter: brightness(1.1);
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        }

        .dropdown-menu {
          position: absolute;
          top: calc(100% + 6px);
          opacity: 0;
          visibility: hidden;
          transform: translateY(-8px) scale(0.97);
          transform-origin: top left;
          transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
          left: 0;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15), 0 4px 10px rgba(0, 0, 0, 0.1);
          border-radius: 10px;
          min-width: 220px;
          z-index: 1000;
          max-height: 400px;
          overflow-y: auto;
          scrollbar-width: thin;
          scrollbar-color: #c5c9d0 transparent;
          background: white;
          border: 1px solid #e2e5ea;
        }

        .dropdown-menu a {
          padding: 8px 12px;
          display: flex;
          align-items: center;
          text-decoration: none;
          color: #4a5568;
          gap: 8px;
          transition: all 0.1s ease;
        }

        .dropdown-menu a:hover {
          background-color: #f0f4f8;
          color: #1a202c;
        }

        .selected {
          background-color: #edf2f7 !important;
          color: #1e40af !important;
          font-weight: bold;
        }

        .open .dropdown-menu {
          opacity: 1;
          visibility: visible;
          transform: translateY(0) scale(1);
        }

        .dropdown-menu::-webkit-scrollbar {
          width: 5px;
        }

        .dropdown-menu::-webkit-scrollbar-track {
          background: transparent;
        }

        .dropdown-menu::-webkit-scrollbar-thumb {
          background-color: #c5c9d0;
          border-radius: 4px;
        }

        .dropdown-menu a.sticky-top {
          position: sticky;
          top: 0;
          z-index: 10;
          background: white;
          padding: 10px 12px;
          border-bottom: 1px solid #e2e5ea;
        }

        .search-input {
          width: 100%;
          padding: 8px 12px;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          font-size: 13px;
          background: #f9fafb;
          color: #1a202c;
          outline: none;
          transition: border-color 0.15s ease;
        }

        .search-input::placeholder {
          color: #9ca3af;
        }

        .search-input:focus {
          border-color: #1e40af;
          background: white;
          box-shadow: 0 0 0 2px rgba(30, 64, 175, 0.1);
        }

        .dropdown-button-text-wrapper {
          max-width: 100px;
          overflow: hidden;
          display: inline-block;
          vertical-align: middle;
          position: relative;
        }
        .dropdown-button-text-marquee {
          display: inline-block;
          white-space: nowrap;
          will-change: transform;
        }
        .dropdown-button-text-marquee.animated {
          animation-name: marquee-pingpong;
          animation-duration: 5s;
          animation-timing-function: linear;
          animation-iteration-count: infinite;
          animation-direction: alternate;
        }
        @keyframes marquee-pingpong {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(var(--marquee-distance, 0));
          }
        }
        .dropdown-button-text {
          white-space: nowrap;
          display: inline-block;
          transition: color 0.2s;
        }
        .dropdown-button-text.marquee {
          animation: marquee 4s linear infinite;
        }
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-100%);
          }
        }
      `]}static get properties(){return{open:{type:Boolean},menuOptions:{type:Array},selected:{type:String},wsColor:{type:String,attribute:!1},status:{type:String,attribute:!1},searchTerm:{type:String},marqueeActive:{type:Boolean},
// nuova proprietà
marqueeDistance:{type:Number},
// nuova proprietà
disabled:{type:Boolean}}}constructor(){super(),this.open=!1,this.menuOptions=[],this.searchTerm="",this.marqueeActive=!1,this.marqueeDistance=0,this._lastScrollWidth=null,this._lastClientWidth=null,this._measuringScheduled=!1,this.disabled=!1}connectedCallback(){super.connectedCallback(),this._boundHandleOutsideClick=this.handleOutsideClick.bind(this),window.addEventListener("click",this._boundHandleOutsideClick)}disconnectedCallback(){window.removeEventListener("click",this._boundHandleOutsideClick),super.disconnectedCallback()}toggleMenu(){this.disabled||(this.open=!this.open)}handleOutsideClick(e){e.composedPath().includes(this)||(this.open=!1)}selectOption(e){this.dispatchEvent(new CustomEvent("option-selected",{detail:e,bubbles:!0,composed:!0})),this.open=!1}connectWorkstation(){this.dispatchEvent(new CustomEvent("connction-click",{detail:this.selected,bubbles:!0,composed:!0}))}updated(e){super.updated&&super.updated(e),// Solo se 'selected' è effettivamente cambiato, non ad ogni render
e.has("selected")&&!this._measuringScheduled&&(this._measuringScheduled=!0,// Usa requestAnimationFrame per aspettare che il layout sia finito
requestAnimationFrame(()=>{var e,t;const s=null===(e=this.shadowRoot)||void 0===e?void 0:e.querySelector(".dropdown-button-text-wrapper"),i=null===(t=this.shadowRoot)||void 0===t?void 0:t.querySelector(".dropdown-button-text, .dropdown-button-text-marquee");if(s&&i){const e=i.scrollWidth,t=s.clientWidth,o=e>t,n=e-t;// Aggiorna le proprietà
this.marqueeActive=o,this.marqueeDistance=n>0?n:0}this._measuringScheduled=!1}))}render(){return i.d`
      <div class="dropdown ${this.open?"open":""}">
        <button class="dropdown-button flex items-center" style="${this.disabled?"cursor: default;":""}" @click=${this.toggleMenu}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="${this.selected&&this.wsColor||"white"}"
            stroke-width="2"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 5c7.18 0 13 5.82 13 13M6 11a7 7 0 017 7m-6 0a1 1 0 11-2 0 1 1 0 012 0z" />
          </svg>
          ${this.selected?i.d`<span class="pl-2">${this.selected}</span>`:l.g}
          ${this.disabled?l.g:i.d`
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 ml-1"
                  style="opacity: 0.7;"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              `}
        </button>
        <div class="dropdown-menu">
          ${this.selected?i.d`
                <a @click="${this.connectWorkstation}" class="sticky-top cursor-pointer" style="border-bottom: 1px solid rgba(255,255,255,0.15); gap: 10px;">
                  <span style="width: 10px; height: 10px; border-radius: 50%; background: ${this.wsColor}; display: inline-block; flex-shrink: 0;"></span>
                  <span class="text-sm font-semibold" style="flex: 1;"
                    >${Object(d.a)("COMMON.STATUS")}: ${this.status?Object(d.a)("COMMON."+this.status):"Error"}</span
                  >
                  <fontawesome-icon name="sync-alt" style="font-size: 12px; opacity: 0.6;"></fontawesome-icon>
                </a>
              `:l.g}

          <div class="p-2">
            <input type="text" placeholder="${Object(d.a)("COMMON.SEARCH")}..." class="search-input" @input=${e=>this.searchTerm=e.target.value} />
          </div>

          ${this.menuOptions.filter(e=>e.label.toLowerCase().includes(this.searchTerm.toLowerCase())).map(e=>i.d`
                <a
                  class="cursor-pointer ${this.selected==e.label?"selected":""}"
                  @click=${t=>{"FONTAWESOME-ICON"!==t.target.tagName&&this.selectOption(e)}}
                >
                  <fontawesome-icon
                    name="${this.selected==e.label?"check":"desktop"}"
                    style="font-size: 12px; opacity: ${this.selected==e.label?"1":"0.5"}; width: 16px; text-align: center;"
                  ></fontawesome-icon>
                  <span class="text-sm font-semibold">${e.label}</span>
                  ${this.selected==e.label?i.d`<fontawesome-icon
                        name="times"
                        style="font-size: 12px; opacity: 0.7; cursor: pointer; margin-left: auto;"
                        @click="${e=>{e.stopPropagation(),this.selectOption(null)}}"
                      ></fontawesome-icon>`:""}
                </a>
              `)}
        </div>
      </div>
    `}}customElements.define("workstation-selection",h);
// EXTERNAL MODULE: ./images/serviziospedalieri/company_logo_small.png?babel-target=es6
var u=s("+Eyj"),p=s("yEz4"),m=s("DQGw"),b=s("XG6N"),g=s("vcFs"),f=s("bZUI"),v=s("zU76"),_=s("xD8C");
// EXTERNAL MODULE: ./src/navigation/navigation.js?babel-target=es6
// CONCATENATED MODULE: ./src/components/top-bar.js?babel-target=es6
class w extends i.b{static get styles(){return[o.a,o.Db,i.c`
        .toolbar-top {
          align-items: center !important;
        }
        .toolbar-top .workstation,
        .toolbar-top .user {
          display: inline-flex !important;
          align-items: center !important;
          padding: 0 12px;
          height: 100%;
        }
        .toolbar-top .workstation .dropdown,
        .toolbar-top .user .dropdown {
          display: inline-flex;
          align-items: center;
        }
        .message-item {
          border-top: none !important;
          border-bottom: 1px dashed #2c3f63 !important;
        }
        .message-item fontawesome-icon {
          flex-grow: 0;
          padding-right: 5px;
          font-size: 11px;
        }
        .dropdown-content {
          width: 220px;
          max-height: 300px;
          overflow: hidden;
          opacity: 0;
          visibility: hidden;
          transform: translateY(-8px) scale(0.97);
          transform-origin: top right;
          transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
          display: block !important;
          background: white;
          border-radius: 10px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15), 0 4px 10px rgba(0, 0, 0, 0.1);
          border: 1px solid #e2e5ea;
          top: calc(100% + 6px);
          right: 0;
        }
        .dropdown:hover .dropdown-content {
          opacity: 1;
          visibility: visible;
          transform: translateY(0) scale(1);
        }
        .dropdown-content ul {
          background: white !important;
          box-shadow: none !important;
          border-radius: 10px !important;
          padding: 0 !important;
          margin: 0 !important;
          list-style: none !important;
          top: 0 !important;
        }
        .dropdown-content ul li {
          color: #4a5568 !important;
          padding: 8px 14px !important;
          width: auto !important;
          box-sizing: border-box !important;
          cursor: pointer;
          transition: background-color 0.1s ease;
          font-size: 14px;
        }
        .dropdown-content ul li:hover {
          background-color: #f0f4f8 !important;
          color: #1a202c !important;
        }
        .dropdown-content ul li div {
          display: flex;
          align-items: center;
          gap: 8px;
          color: inherit;
        }
        .dropdown-content ul li i {
          font-size: 13px;
          width: 16px;
          text-align: center;
        }
        .dr-complaint {
          background: #fd9c86;
          padding: 0 10px;
          border-radius: 5px;
          border: none;
          display: inline-flex;
          align-items: center;
        }
        .dr {
          background: #fff;
          padding: 0 10px;
          border-radius: 5px;
          border: none;
          display: inline-flex;
          align-items: center;
        }
        .version-num {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: small;
          color: #888888;
          font-style: italic;
          padding-top: 7px;
          max-width: 280px;
        }

        .toolbar-top-logo img {
          min-width: 120px;
        }

        @media (max-width: 1043px) {
          search-input-decorator {
            display: none;
          }

          .company-title {
            max-width: 150px;
          }

          .notification {
            display: none !important;
          }
        }

        @media (max-width: 880px) {
          .workstation-selection {
            display: none !important;
          }

          .version-num {
            display: none !important;
          }

          .company-title {
            max-width: auto;
          }
        }

        @media (max-width: 644px) {
          .toolbar-top-logo img {
            display: none;
          }

          .role {
            display: none !important;
          }
        }
      `]}render(){return i.d`
      <app-header condenses fixed effects="waterfall">
        <app-toolbar class="toolbar-top flex items-center justify-between" .style="${this.pwaMode?"":"display: none;"}">
          <div class="flex items-center">
            <a @click="${this._buttonClicked}"><fontawesome-icon prefix="fas" name="bars"></fontawesome-icon></a>
            <div class="toolbar-top-logo">
              <img src="${u.a}" alt="${this.appTitle}" title="${this.appTitle}" @click="${this._buttonClicked}" />
            </div>
            ${this._buildNum?i.d` <b class="version-num"> ${this._buildNum} </b> `:l.g}
          </div>
          ${"xyz"!==this.page?i.d`
                <search-input-decorator style="margin-left: 10px" top>
                  <input
                    autocomplete="off"
                    slot="input"
                    id="inputSearch"
                    aria-label="${Object(d.a)("COMMON.SEARCH")}"
                    type="search"
                    list="menulist"
                    @change="${e=>this._onSearchInputChanged(e)}"
                  />
                  <datalist id="menulist"> </datalist>
                  <speech-mic slot="button" continuous interimResults @result="${e=>this._result(e)}"></speech-mic>
                </search-input-decorator>
              `:i.d`
                <six-code-reader
                  label=""
                  buttonLabel="${"COMMON.BARCODE"}"
                  placeholder="${"COMMON.BARCODE"}"
                  id="codeReaderElement"
                  milliseconds
                  top
                ></six-code-reader>
              `}

          <div class="flex items-center">
            ${this.notificationsCount?i.d` <div class="workstation">
                  <div class="dropdown dr">
                    <six-title
                      color="${"rekeep"!=g.a?"":"white"}"
                      @click="${this._goToMessages}"
                      class="topbar-title blue truncate"
                      icon="bell"
                      label="${this.notificationsCount}"
                      useFontawesome
                    ></six-title>
                    <div class="dropdown-content">
                      <ul>
                        ${this.notifications&&this.notifications.length?this.notifications.map(e=>i.d` <li class="message-item">
                                <div @click="${()=>m.a.dispatch(Object(p.c)("message/handle/"+e.process_instance_id))}" style="display: flex;">
                                  <fontawesome-icon prefix="fas" name="envelope"></fontawesome-icon>
                                  <div style="flex-grow: 1;"><strong>${e.lastSender.toUpperCase()}</strong>: ${e.lastMessage}</div>
                                </div>
                              </li>`):l.g}
                      </ul>
                    </div>
                  </div>
                </div>`:""}
            ${this.complaintsCount?i.d` <div class="workstation">
                  <div class="dropdown dr-complaint">
                    <six-title
                      color="${"rekeep"!=g.a?"":"white"}"
                      @click="${this._goToMessages}"
                      class="topbar-title blue truncate"
                      icon="exclamation-triangle"
                      label="${this.complaintsCount}"
                      useFontawesome
                    ></six-title>
                    <div class="dropdown-content">
                      <ul>
                        ${this.complaints&&this.complaints.length?this.complaints.map(e=>i.d` <li class="message-item">
                                <div @click="${()=>m.a.dispatch(Object(p.c)("ticket/handle/"+e.taskId))}">
                                  <div style="display: flex; justify-content: space-between; align-items:flex-start; align-content:flex-start;">
                                    <div style="display: flex;">
                                      <fontawesome-icon prefix="fas" name="exclamation-triangle"></fontawesome-icon>
                                      <strong>${e.lastSender.toUpperCase()}</strong>
                                    </div>
                                    <span style="flex-grow: 0; background: #FFF; border-radius: 3px; padding: 0px 3px; color: #253655; align-self:flex-start;"
                                      >${Object(d.a)("COMMON."+e.status)}</span
                                    >
                                  </div>
                                  <div class="complaint-message">${e.lastMessage}</div>
                                  <div style="text-align: right; font-style: italic; font-size: 10px;">
                                    ${e.customer_description} ${e.destination_description}
                                  </div>
                                </div>
                              </li>`):l.g}
                      </ul>
                    </div>
                  </div>
                </div>`:""}
            ${this.showUnderstockPercentageAlert&&this._checkDestinationsUnderstockPercentage?i.d`
                  <div class="workstation">
                    <div
                      class="dropdown animate-pulse rounded border border-red-700 flex px-1"
                      style="padding: 0;font-size: 15px;background-color: var(--app-danger-color)"
                      @click="${()=>m.a.dispatch(Object(p.c)("destination-understock-report"))}"
                    >
                      <fontawesome-icon class="px-1 text-white" name="exclamation-triangle"></fontawesome-icon>
                      <p class="text-xs pr-1"><i>${Object(d.a)("COMMON.UNDERSTOCK").toLowerCase()}</i></p>
                    </div>
                  </div>
                `:l.g}

            <div class="workstation">
              <div class="dropdown">
                <six-notification
                  @notification-read=${this._onNotification}
                  .username="${this.username.user}"
                  .role="${this.role}"
                  .notificationWebsocketUrl="${this.notificationWebsocketUrl}"
                  .workstationCode="${this.workstationCode}"
                ></six-notification>
              </div>
            </div>

            <div class="workstation">
              <div class="dropdown">
                <workstation-selection
                  .selected="${this.workstationCode}"
                  .menuOptions="${this._workstations}"
                  @option-selected="${this._setWorkstation}"
                  @connction-click="${this._connectCurrentWs}"
                  .status="${this.websocketStatus}"
                  .wsColor="${this._getWsStatusColor()}"
                  ?disabled="${this.disableWebsocket}"
                ></workstation-selection>
              </div>
            </div>

            <div class="workstation">
              <div class="dropdown">
                <six-title
                  class="topbar-title truncate"
                  title="${this.company.company} - ${this.company.division}"
                  icon="home"
                  label="${this.company.company} - ${this.company.division}"
                  useFontawesome
                ></six-title>
              </div>
            </div>

            <div class="workstation">
              <div class="dropdown">
                <six-title title="${this.role}" class="topbar-title truncate" icon="id-card" label="${this.role}" useFontawesome></six-title>
              </div>
            </div>

            <div class="user">
              <div class="dropdown">
                <six-title
                  title="${this.username.name||""} ${this.username.surname||""} (${this.username.user})"
                  class="topbar-title truncate"
                  icon="user"
                  label="${this.username.name||""} ${this.username.surname||""} (${this.username.user})"
                  useFontawesome
                ></six-title>
                <div class="dropdown-content">
                  <ul>
                    ${this.advancedMenu?i.d`
                          <li>
                            <div @click="${()=>this._onMenuVoiceClick("admin",!0)}">
                              <fontawesome-icon prefix="fas" name="cog" fixed-width></fontawesome-icon>${Object(d.a)("COMMON.ADMIN")}
                            </div>
                          </li>
                        `:l.g}
                    <li>
                      <div @click="${()=>this._onMenuVoiceClick("preferences",!0)}">
                        <fontawesome-icon prefix="fas" name="sliders-h" fixed-width></fontawesome-icon>${Object(d.a)("COMMON.PREFERENCES")}
                      </div>
                    </li>
                    <li>
                      <div @click="${()=>this._onMenuVoiceClick("logout",!0)}">
                        <fontawesome-icon prefix="fas" name="sign-out-alt" fixed-width style="color: #e53e3e;"></fontawesome-icon>${Object(d.a)("COMMON.LOGOUT")}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <fontawesome-icon
              @click="${()=>this._onMenuVoiceClick("logout",!0)}"
              style="cursor:pointer; color: var(--logout-btn-color)"
              name="power-off"
              prefix="fas"
              fixed-width
            ></fontawesome-icon>
          </div>
        </app-toolbar>

        <!-- This gets hidden on a small screen-->
      </app-header>
    `}static get properties(){return{page:{type:String},bookmarks:{type:Array},workstationCode:{type:String},username:{type:Object},pwaMode:{type:Boolean},appTitle:{type:String},menu:{type:Array},advancedMenu:{type:Boolean},company:{type:Object},notificationWebsocketUrl:{type:String},role:{type:String},notificationsCount:{type:Number},notifications:{type:Array},complaints:{type:Array},complaintsCount:{type:Number},websocketStatus:{type:String},showUnderstockPercentageAlert:{type:Boolean},disableWebsocket:{type:Boolean},_buildNum:{attribute:!1},_checkDestinationsUnderstockPercentage:{attribute:!1},_workstations:{attribute:!1}}}constructor(){super(),this.notificationsCount=0,this.notifications=[],this.websocketStatus="",this.showUnderstockPercentageAlert=!1,this._workstations=[],this.disableWebsocket=!1}firstUpdated(){this._flattenMenu=this._flatten(this.menu),this._api=new b.a,this._apiCommon=new v.a,this._api.getBuildNum().then(e=>this._buildNum=null==e?void 0:e.value),this._apiCommon.getWorkstations().then(e=>{this._workstations=[...e.list].map(e=>({label:e.code,value:e}))})}updated(e){e.has("menu")&&(this._menuList=this._flattenMenu.sort((e,t)=>{let s=(e.title||"").toUpperCase(),i=(t.title||"").toUpperCase();return s<i?-1:s>i?1:0}),this._resetSearchBarDataList(this._menuList)),e.has("showUnderstockPercentageAlert")&&this.showUnderstockPercentageAlert&&(this._searchForUndestockDestinations(),setInterval(()=>this._searchForUndestockDestinations(),9e5))}
/******************************************************************* */closeWebsocket(){this.shadowRoot.querySelector("six-notification").closeWebsocket()}_flatten(e){const t=[],s=e=>{e.forEach(e=>{e.children&&e.children.length?s(e.children):t.push({page:e.code,title:e.description})})};return s(e),t}_autocomplete(e){let t=e.target,s=this.shadowRoot.querySelector("#menulist");s.innerHTML="",this._menuList.filter(e=>e.title.toLowerCase().indexOf(t.value.toLowerCase())>-1).forEach(e=>{const t=document.createElement("option");t.value=e.title,t.page=e.page,s.appendChild(t)})}_onSearchInputChanged(){let e=this.shadowRoot.querySelector("#inputSearch").value,t=this.shadowRoot.querySelector(`#menulist option[value="${e}"]`),s=t&&t.page||e;this.shadowRoot.querySelector("#inputSearch").value="",this.shadowRoot.querySelector("#inputSearch").blur(),this._resetSearchBarDataList(this._menuList),this.dispatchEvent(new CustomEvent("changeSearch",{detail:{value:s}}))}_resetSearchBarDataList(e){let t=this.shadowRoot.querySelector("#menulist");t.innerHTML="";for(let s=0;s<e.length;s++){
// rendering più veloce dei risultati, testato
const i=e[s],o=document.createElement("option");o.value=i.title,o.page=i.page,t.appendChild(o)}}_onMenuVoiceClick(e,t){this.dispatchEvent(new CustomEvent("menuVoiceClick",{detail:{key:e,value:t}}))}_buttonClicked(){this.dispatchEvent(new CustomEvent("buttonClicked",{detail:{value:!0}}))}_result(e){this.dispatchEvent(new CustomEvent("result",{detail:{value:e}}))}_onNotification(e){this.dispatchEvent(new CustomEvent("notification-read",{detail:{value:e.detail.value}}))}_goToMessages(){m.a.dispatch(Object(p.c)("message/list"))}_getWsStatusColor(){let e="";switch(this.websocketStatus){case"OPEN":e="var(--app-success-color)";break;case"CLOSE":default:e="var(--app-danger-color)"}return e}_connectCurrentWs(){this.dispatchEvent(new CustomEvent("reconnectWebSocket",{detail:{value:!0}}))}_searchForUndestockDestinations(){
/* client
      .watchQuery({
        query: gql`
          query boh {
            destination_understock_report_aggregate(where: { understock: { _eq: "T" } }) {
              aggregate {
                count
              }
            }
          }
        `,
      })
      .subscribe({
        next: (data) => {
          console.log(data);
        }
        error: (e) => console.error(e),
      }); */
let e=[{kind:"number",column:"t.current_stock_percentage",relation:"<",value:"t.understock_percentage"}];(Object(f.k)(m.a.getState())||[]).length>0&&(e=[...e,{column:"customer_destination_user cdu",relation:"JOIN",value:"t.customer_destination_id = cdu.customer_destination_id"},{column:"users u",relation:"JOIN",value:"cdu.user_id = u.id"},{column:"u.username",kind:"string",relation:"=",value:""+Object(f.c)(m.a.getState())}]),this._api.getDestinationUnderstockReport(1,1,"",e).then(e=>this._checkDestinationsUnderstockPercentage=e.totalResults>0)}_setWorkstation(e){var t;const s=null==e||null===(t=e.detail)||void 0===t?void 0:t.value;let i;null!=s&&s.id?(i={id:s.id,code:s.code,websocket_url:s.websocket_url,debounce:s.debounce,type:s.type},//stampante di default
s.default_label_printer_id&&(i.default_printer={id:s.default_label_printer_id,code:s.default_label_printer_code,description:s.default_label_printer_description})):(i={id:0,code:"",websocket_url:"",default_printer:{}},this.dispatchEvent(new CustomEvent("closeWebSocket",{detail:{value:!1}}))),m.a.dispatch(Object(_.j)(i)),localStorage.setItem("workstation",JSON.stringify(i))}}window.customElements.define("top-bar",w)},
/***/fbHz:
/***/function(e,t,s){"use strict";
/* harmony import */var i=s("Rukz"),o=s("hR6X");
/* harmony import */class n extends i.b{static get properties(){return{active:{type:Boolean}}}static get styles(){return[o.Ab]}render(){return i.d`
      <slot></slot>
    `}}window.customElements.define("snack-bar",n)},
/***/jrL5:
/***/function(e,t,s){"use strict";
/* harmony import */var i=s("Rukz"),o=s("hR6X"),n=s("zKOZ");
/* harmony import */
// This element is *not* connected to the Redux store.
class a extends i.b{static get styles(){return[o.Db]}static get properties(){return{classesList:{type:String},cornerClassesList:{type:String},width:{type:String},tooltipText:{type:String},useDefaultClasses:{type:Boolean},showCorner:{type:Boolean},_show:{type:Boolean},mode:{type:String},enabledEvents:{type:Array},stylesString:{type:String}}}constructor(){super(),this._defaultClasses="absolute bottom-0 left-0",this._show=!1,this.classesList="",this.useDefaultClasses=!1,this.width="100px",this.defaultCornerClassesList="absolute",this.cornerClassesList="",this.enabledEvents=["over","leave"],this.stylesString=""}firstUpdated(){switch(this.mode){case"left":this.cornerClassesList+=" right-0 top-0 border-r-2 border-t-2 ",this.classesList+=" absolute right-0 top-0 rounded-l-lg rounded-b-lg rounded-t-lg ";break;case"right":this.cornerClassesList+=" left-0 top-0 border-l-2 border-t-2 ",this.classesList+=" absolute left-0 top-0 rounded-r-lg rounded-b-lg rounded-t-lg ";break;case"top-center":this.cornerClassesList+=" left-0 top-0 right-0 border-l-2 border-t-2 ",this.classesList+=" absolute left-0 top-0 right-0 "}}render(){return i.d`
      <div
        class="absolute cursor-pointer"
        @mouseover="${()=>this._display("over",!0)}"
        @click="${()=>this._display("click",!this._show)}}"
        @mouseleave="${()=>this._display("leave",!1)}}"
      >
        <div>
          <slot class="pointer" name="content"></slot>
        </div>
        ${this._show?i.d` <div style="z-index: 10000;" class="corner ${this.defaultCornerClassesList} ${this.cornerClassesList}"></div>
              <div style="z-index: 9999; width: ${this.width}; ${this.stylesString}" id="tooltip-container" class="${this.classesList}">
                <span>${Object(n.a)(this.tooltipText)}</span>
              </div>`:""}
      </div>
    `}_getWidth(){return this.width||"100px"}_display(e,t){this.enabledEvents.includes(e)&&(this._show=t)}}window.customElements.define("six-tooltip-content",a)},
/***/vBTZ:
/***/function(e,t,s){"use strict";
/* harmony import */var i=s("Rukz");class o extends i.b{static get styles(){return[]}static get properties(){return{value:{type:String,reflect:!0},
// Read code (unicode, barcode or badge)
read:{type:Object,reflect:!0},
// Read received from websocket (as object like {"type":"R","read":"300ED89F3350004000393825","ts":1548410055603} ).
auto:{type:Boolean},
// If true, opens connection at ready event.
url:{type:String},
// Web-socket url (eg. ws://docker0.ict-group.it:8666/clients/WS-01).
milliseconds:{type:Boolean}}}render(){return i.d` <div></div> `}constructor(){super(),this.auto=!1,this.milliseconds=!1}disconnectedCallback(){this.closeWebsocket()}updated(e){e.has("url")&&this.url&&this.auto&&(this.closeWebsocket(),this.openWebsocket())}
/****************************************************************** */keepAlive(){this._websocket&&(!this._websocket.readyState==this._websocket.OPEN?console.log("Connection NOT opened with websocket "+this.url):this._websocket.send('{"code":"_all"}'))}openWebsocket(){if(!this.url)throw Error("url property is required");this._websocket=new WebSocket(this.url,this.protocols),this._websocket.onopen=this._onOpen.bind(this),this._websocket.onclose=this._onClose.bind(this),this._websocket.onmessage=this._onMessage.bind(this),this._websocket.onerror=this._onError.bind(this)}closeWebsocket(){this._websocket&&(this._stopReconnectionInterval(),this._skipReconnection=!0,this._websocket.close(),this._websocket=null)}reconnectWebSocket(){this.closeWebsocket(),this.openWebsocket()}_onOpen(){console.log("Connection opened with websocket "+this.url),this._statusNotify("OPEN")}_onClose(){console.log("Connection closed with websocket "+this.url),this._websocket=null,this._statusNotify("CLOSED"),this._startReconnectionInterval()}_onError(){console.log("connection error"),this._websocket=null,this._statusNotify("ERROR")}_startReconnectionInterval(){this._reconnectionInterval||(this._skipReconnection?this._stopReconnectionInterval():this._reconnectionInterval=setInterval(()=>{this.url&&!this._websocket?(console.log("reconnection interval: openWebsocket"),this.openWebsocket()):(console.log("reconnection interval: end"),this._stopReconnectionInterval())},5e3))}_stopReconnectionInterval(){this._skipReconnection=null,this._reconnectionInterval&&(clearInterval(this._reconnectionInterval),this._reconnectionInterval=null)}_onMessage(e){let t=JSON.parse(e.data);for(let e of t.reads)this.value=e.read,this.milliseconds||(e.ts=new Date(e.ts)),this.read=e,this._notify()}
/**
   * Read event broadcast.
   */_notify(){this.dispatchEvent(new CustomEvent("websocket-message",{detail:{value:this.value,read:this.read}}))}_statusNotify(e){this.dispatchEvent(new CustomEvent("status-notify",{detail:{status:e}}))}}window.customElements.define("six-websocket-listener",o)},
/***/vcFs:
/***/function(e,t,s){"use strict";
/* harmony export (binding) */s.d(t,"d",(function(){return i})),
/* harmony export (binding) */s.d(t,"a",(function(){return o})),
/* harmony export (binding) */s.d(t,"b",(function(){return n})),
/* harmony export (binding) */s.d(t,"c",(function(){return a}));
// inizializzate a build-time da webpack, private.
// eslint-disable-next-line no-undef
const i=!0,o="serviziospedalieri",n="serviziospedalieri",a={};// eslint-disable-next-line no-undef
},
/***/zbnX:
/***/function(e,t,s){"use strict";
/* harmony export (binding) */s.d(t,"a",(function(){return a}));
/* harmony import */var i=s("Rukz"),o=s("yzKQ"),n=s("jimv");
/* harmony import */class a extends i.b{constructor(){super(),
/**
     * Function to automatically trigger the requestUpdate when the controlled values are changed.
     * Only one call to this function must exist for it to work properly, and by convention
     * this must be inside the stateChanged function.
     *
     * Values are comapred using '==='.
     * Only for properties belonging to the redux store.
     * @deprecated
     * @function watchState
     * @param  {...any} values proprietà dello state che devono triggerare l'update della view all'assegnazione di un nuovo valore
     * @returns {Array<Number>} gli indici delle proprietà che sono cambiate
     */
this.watchState=function(e){let t={},s=null;return(...i)=>{let o=[],n=!1;return i.forEach((e,s)=>{t[s]!==e&&(o.push(s),n=!0),t[s]=e}),n&&(clearTimeout(s),s=setTimeout(()=>{e()},250)),o}}
/***/(this.requestUpdate.bind(this))}
/**
   * set the i18n root key for the message functions and
   * sxTranslation functions provided in the class.
   * default 'COMMON'
   * @abstract
   */getI18nBaseKey(){return"COMMON"}
/**
   * Translates a string and returns it. The string is prefixed with the value returned by the getI18nBaseKey() function.
   * Fallback on COMMON namespace if the page doesen't provide the specified key.
   * If you don't want the fallback, use translate() from six-utils
   * @param {String} string - String to translate. can be i18n key or raw string
   * @param {string[]} interpolate - Array of values to replace in the string.
   * @example
   *  sxTranslate("{0} marc, {1}", ["hello", "nice to meet you"])
   * @return {String} Tranlsation
   */sxTranslate(e,t){return Object(n.b)(this.getI18nBaseKey(),"COMMON",e,t)}
/**
   * Message options
   * @typedef {Object} MessageOption
   * @property {string} [title] - The title
   * @property {'top-stretch'|'top-start'|'top-center'|'top-end'|'middle'|'bottom-start'|'bottom-center'|'bottom-end'|'bottom-stretch'} [position='bottom-end'] - The position
   * @property {number} [duration = 4000] - The duration
   * @property {String[]} [interpolate] - Array of strings or i18n keys to replace in the message. can be mixed
   * @property {boolean} okButton - show ok action button on notification
   * @property {boolean} cancelButton - show cancel action button on notification
   * @property {string} okButtonText - ok action button label
   * @property {string} cancelButtonText - cancel action button label
   * @property {string} customStyle - custom css
   */
/** Display a popup message.
   * The string is prefixed with the value returned by the getI18nBaseKey() function.
   * if the function is not implemented in the child class, the COMMON key is used as a fallback
   * @param {String} messageCode - Message to show. Must be i18n key.
   * @param {MessageOption} [options] - message options
   * @returns {Promise} - Promise
   */displayMessage(e,{title:t,position:s,duration:i,interpolate:n,okButton:a,cancelButton:r,okButtonText:l,cancelButtonText:c,customStyle:d}={}){return Object(o.a)("success",this.getI18nBaseKey(),t,e,n,s,i,a,r,l,c,d)}
/** Display a popup message.
   * The string is prefixed with the value returned by the getI18nBaseKey() function.
   * if the function is not implemented in the child class, the COMMON key is used as a fallback
   * @param {String} messageCode - Message to show. Must be i18n key.
   * @param {MessageOption} [options] - message options
   * @returns {Promise} - Promise
   */errorMessage(e,{title:t,position:s,duration:i,interpolate:n,okButton:a,cancelButton:r,okButtonText:l,cancelButtonText:c,customStyle:d}={}){return Object(o.a)("error",this.getI18nBaseKey(),t,e,n,s,i,a,r,l,c,d)}
/** Display a popup message.
   * The string is prefixed with the value returned by the getI18nBaseKey() function.
   * if the function is not implemented in the child class, the COMMON key is used as a fallback
   * @param {String} messageCode - Message to show. Must be i18n key.
   * @param {MessageOption} [options] - message options
   * @returns {Promise} - Promise
   */warnMessage(e,{title:t,position:s,duration:i,interpolate:n,okButton:a,cancelButton:r,okButtonText:l,cancelButtonText:c,customStyle:d}={}){return Object(o.a)("warning",this.getI18nBaseKey(),t,e,n,s,i,a,r,l,c,d)}
/** Display a popup message.
   * The string is prefixed with the value returned by the getI18nBaseKey() function.
   * if the function is not implemented in the child class, the COMMON key is used as a fallback
   * @param {String} messageCode - Message to show. Must be i18n key.
   * @param {MessageOption} [options] - message options
   * @returns {Promise} - Promise
   */infoMessage(e,{title:t,position:s,duration:i,interpolate:n,okButton:a,cancelButton:r,okButtonText:l,cancelButtonText:c,customStyle:d}={}){return Object(o.a)("info",this.getI18nBaseKey(),t,e,n,s,i,a,r,l,c,d)}
/*   debounce(f, interval) {
    let timer = null;
     return (...args) => {
      clearTimeout(timer);
      return new Promise((resolve) => {
        timer = setTimeout(
          () => resolve(f(...args)),
          interval,
        );
      });
    };
  } */}}}]);